import { DefaultSections, startPresentation } from "@presentation/Types";

import Introduction from "./Slides/IntroAndOutro/Introduction.vue";
import ThankYou from "./Slides/IntroAndOutro/ThankYou.vue";
import SoftMarket from "./Slides/Challenges/SoftMarket.vue";
import Goodwill from "./Slides/Challenges/Goodwill.vue";
import Solution from "./Slides/Challenges/Solution.vue";
import Results from "./Slides/SuccessLeavesATrail/Results.vue";
import BuyerInterest from "./Slides/SuccessLeavesATrail/BuyerInterest.vue";
import Subscriptions from "./Slides/SuccessLeavesATrail/Subscriptions.vue";
import LoyaltyPrograms from "./Slides/SuccessLeavesATrail/LoyaltyPrograms.vue";
import AirlineLoyaltyExample from "./Slides/SuccessLeavesATrail/AirlineLoyaltyExample.vue";
import Partnership from "./Slides/Partnership/Partnership.vue";
import Clues from "./Slides/SuccessLeavesATrail/Clues.vue";
import ConnectedVehiclesOverview from "./Slides/History/ConnectedVehiclesOverview.vue";
import OurHistory from "./Slides/History/OurHistory.vue";
import WeAreHere from "./Slides/History/WeAreHere.vue";
import UsefulLinks from "./Slides/UsefulLinks/UsefulLinks.vue";

export const useSalesPresentation = () => startPresentation(
{

    key: 'sales-full',
    title: 'Sales Presentation',
    password: 'cvpg', 
    enableNextSlideIndicator: true,

    sections: [

        // Introduction
        { 
            name: DefaultSections.Start, 
            title: 'Introduction',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Introduction }
            ],
            images: [
                '/carbucks-driven-by-presidian.png',
                '/carbucks-logo.png',
                '/background-overlay.jpg',
                '/pending.jpg'
            ]
        },

        // Challenges
        { 
            name: 'challenges', 
            title: 'Challenges',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: SoftMarket },
                { component: Goodwill },
                { component: Solution }
            ],
            images: [
                '/Challenge/goodwill.png',
                '/Challenge/uncertain-future.png',
                '/Challenge/solution.png'
            ]   
        },

        // Success Leaves a Trail
        { 
            name: 'success-leaves-a-trail', 
            title: 'Success Leaves a Trail',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: Clues },
                { component: Results },
                { component: BuyerInterest },
                { component: Subscriptions },
                { component: LoyaltyPrograms },
                { component: AirlineLoyaltyExample },
            ],
            images: [
                '/SuccessLeavesATrail/buyer-interest.png',
                '/SuccessLeavesATrail/subscriptions.jpg',
                '/SuccessLeavesATrail/results.png',
                '/SuccessLeavesATrail/loyalty-programs.png',
                '/SuccessLeavesATrail/airline-example.png'
            ]   
        },

        // What is Carbucks
        { 
            name: 'what-is-carbucks'
        },

        // Marketplace
        { 
            name: 'marketplace'
        },

        // Consumer Proposition
        { 
            name: 'consumer-proposition'
        },

        // Demo
        { 
            name: 'demo'
        },

        // Dealer Proposition
        { 
            name: 'dealer-proposition'
        },

        // Thank You
        { 
            name: DefaultSections.End, 
            title: 'Questions',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: ThankYou }
            ],
            images: [ 
                '/background-overlay-3.jpg',
            ]   
        },
        
        // Case Study
        { 
            name: 'case-study'  
        },

        // Point of Sale
        { 
            name: 'point-of-sale'
        },

        // Terms and Conditions
        { 
            name: 'terms-and-conditions'
        },

        // Dealer Cashback
        { 
            name: 'dealer-cashback'  
        },

        // DMS Integration
        { 
            name: 'dms-integration'
        },

        // Our History
        { 
            name: 'history', 
            title: 'Our History',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: ConnectedVehiclesOverview, title: 'Company Overview', hideTitle: true },
                { component: OurHistory, title: 'Our History' },
                { component: WeAreHere, title: "We are Here" },
            ],
            images: [
                '/History/connected-vehicles-logo-white.png',
                '/History/dealercell.jpg',
                '/History/we-are-here.jpg'
            ]   
        },

        // Partnership
        { 
            name: 'partnership', 
            title: 'Presidian / CV Partnership',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: Partnership }
            ],
            images: [
                '/connected-vehicles-logo.png',
                '/presidian-group-logo.png',
            ]   
        },

        // LINKS
        { 
            name: 'links', 
            title: 'Useful Links',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: UsefulLinks }
            ],
            images: [

            ]   
        }

    ]

})
